import { createActionConst } from '../../../../utils/action.utils';

const MEETING_FORM_NAMESPACE = 'MEETING_FORM';

export const INITIAL_MEETING_FORM = createActionConst(MEETING_FORM_NAMESPACE, 'INITIAL_MEETING_FORM');
